import React, { useState, useEffect, useRef, useCallback } from 'react';
import {BackgroundContainer} from "./styled";

export const ParallaxBackground = ({ imageUrl, speedFactor = -0.5, height,back=true }) => {

    const [translateY, setTranslateY] = useState(0);
    const containerRef = useRef(null);

    const handleScroll = useCallback(() => {
        if (!containerRef.current) return;

        const rect = containerRef.current.getBoundingClientRect();
        const elemTop = rect.top;
        const elemHeight = rect.height;
        const viewportHeight = window.innerHeight;

        const scrollCenter = (elemTop + elemHeight / 2) - (viewportHeight / 2);

        const translation = scrollCenter * -speedFactor;

        setTranslateY(translation);
    }, [speedFactor]);

    useEffect(() => {
        handleScroll();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, [handleScroll]);

    return (
        <BackgroundContainer
            ref={containerRef}
            imageUrl={imageUrl}
            height={height}
            back={back}
            style={{
                transform: `translateY(${translateY}px)`
            }}
        />
    );
};